import React from 'react';
import _ from 'lodash';

import './Combinations.scss';
import { useTranslation } from 'react-i18next';
import Icon from 'src/components/Icon/Icon';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { RootState, select } from 'src/configs/store';
import PermutationBet from 'src/components/Betslip/PermutationBet/PermutationBet';

interface CombinationsProps {
  totalCombinations: number
}

function Combinations({ totalCombinations } : CombinationsProps) {
  const { t } = useTranslation();

  const showPermutations = useSelector((state: RootState) => state.betslip.readShowPermutations);
  const readOpenCombinations = useSelector((state: RootState) => state.betslip.readOpenCombinations);

  const combinations = useSelector(select.betslip.combinations);
  let permutationsIndex = 0;

  return (
    <>
      <div className="combinations-container">
        <span className="combinations-container__title">{ `${ t('secondScreen.lineCombinations') } ${ totalCombinations }` }</span>
        <Icon
          icon="arrow"
          className={ classNames('combinations-container__dropdown-arrow', { 'combinations-container__dropdown-arrow--opened': showPermutations }) }
        />
      </div>
      {
        showPermutations && (
          _.map(Object.keys(combinations), (key, index) => {
            if (index > 0) permutationsIndex += Object.values(combinations)[index - 1].length || 0;

            return (
              <PermutationBet
                key={ key }
                startIndex={ permutationsIndex }
                combination={ combinations[key] }
                index={ index + 1 }
                setOpen= { () => {} }
                openCombinations={ readOpenCombinations }
                name={ key }
                allowStakes={ false }
                isSecondScreen
              />
            );
          })
        )
      }
    </>
  );
}

export default Combinations;
